import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Game from "./Game";
import Resources from "./Resources";
import Home from "./Home";
// import DiceRoller from './DiceRoller';
import PressKit from "./PressKit";
import License from "./License";
import Logos from "./Logos";
import Buy from "./Buy";

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/*" element={<App />}>
          <Route index element={<Home />} />
          <Route path="game" element={<Game />} />
          <Route path="resources" element={<Resources />} />
          <Route path="presskit" element={<PressKit />} />
          <Route path="license" element={<License />} />
          <Route path="logos" element={<Logos />} />
          <Route path="buy" element={<Buy />} />
          {/* <Route path="resources/roller" element={<DiceRoller />} /> */}
        </Route>
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
